// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__Yse8z","questions":"Faq_questions__rC9eA"};